export default "__VITE_ASSET__B9av1tWz__"